module.exports = __webpack_public_path__ + "img/Pelletheizung-Pro-Kontra.8753960.png";